import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent';
import DropdownMenu from '../../shared/styledComponents/DropdownMenu';

export default InjectedStyledComponent(DropdownMenu, 'iconDropdown', ['menu']);